/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Report_Net_Cash_FlowInputs */

const vi_expense_report_net_cash_flow = /** @type {(inputs: Expense_Report_Net_Cash_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chênh lệch thu - chi`)
};

/**

* @param {Expense_Report_Net_Cash_FlowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_report_net_cash_flow = /** @type {((inputs?: Expense_Report_Net_Cash_FlowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Report_Net_Cash_FlowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_report_net_cash_flow(inputs)
});